/**
 * CONTACT-FORM.JS
 *
 * Initialization of the validation of the contact form.
 */

export default function InitContactForm() {
	const axios = require('axios');
	axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

	const form = document.querySelector('.contact-form form');

	if (!form)
		return;

	const successText = form.querySelector('#contact-form-success');
	const errorText = form.querySelector('#contact-form-error');
	const buttonSubmit = form.querySelector('#button-submit-contact-form');
	let loadingSpinner = buttonSubmit.querySelector('.animate-spin');

	form.addEventListener('submit', (event) => {
		event.preventDefault();

		loadingSpinner.classList.remove('hidden');

		axios.post(form.action, new FormData(form))
			.then(() => {
				HideErrorFields(form);
				ClearAllFields(form);

				errorText.classList.add('hidden');
				successText.classList.remove('hidden');
			})
			.catch((error) => {

				successText.classList.add('hidden');
				HideErrorFields(form);

				if (error.response) {
					// Request made and server responded
					if (error.response.data && error.response.data.error && error.response.status == 400)
						HandleFormErrors(form, error.response.data.error);
					else errorText.classList.remove('hidden');

				} else if (error.request) {
					// The request was made but no response was received
					console.log(error.request);
					errorText.classList.remove('hidden');
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
					errorText.classList.remove('hidden');
				}
			}).then(() => {
			loadingSpinner.classList.add('hidden');
		});
	});
}

/**
 * Shows errors at the respective position.
 * Example: If passed errors array contains a 'name' key, the error message will be placed below the Name field in the form
 * @param {Element} form
 * @param {Array} errors
 */
function HandleFormErrors(form, errors) {
	Object.keys(errors).forEach((key) => {
		let error = errors[key];
		let input = form.querySelector('input[name="' + key + '"]');

		if (!input)
			input = form.querySelector('input[name="' + key + '[]"]');

		if (!input)
			return;

		let formField = input.closest('.form-field');
		if (!formField)
			return;

		let inputError = formField.querySelector('.input-error');
		if (!inputError)
			return;

		inputError.innerHTML = error;
		inputError.classList.remove('hidden');
	});
}

/**
 * Hides all error fields in the passed form by assigning the css class 'hidden' to each of them
 * @param {Element} form
 */
function HideErrorFields(form) {
	const errorFields = form.querySelectorAll('.input-error');
	errorFields.forEach((errorField) => {
		errorField.classList.add('hidden');
	});
}

/**
 * Searches for all inputs/textareas in the passed forms and clears the values
 * @param {Element} form
 */
function ClearAllFields(form) {
	const formFields = form.querySelectorAll('input, textarea');

	formFields.forEach((field) => {
		field.checked = false;

		if (field.type !== 'checkbox')
			field.value = null;
	});
}